import LayoutBreadcrumb from "./Breadcrumb";
import Content from "./Content";
import ContentBody from "./ContentBody";
import ContentHeader from "./ContentHeader";
import ContentHeaderTopNav from "./ContentHeaderTopNav";
import Provider from "./Provider";
import Root from "./Root";
import Sidebar from "./Sidebar";
import SidebarBody from "./SidebarBody";
import SidebarBodyCategory from "./SidebarBodyCategory";
import SidebarBodyCategoryItem from "./SidebarBodyCategoryItem";
import SidebarBodyExpandItem from "./SidebarBodyExpandItem";
import SidebarHeader from "./SidebarHeader";
import UserMenu from "./UserMenu";

export const Layout = {
  Provider,
  Root,
  Content,
  ContentBody,
  ContentHeader,
  ContentHeaderTopNav,
  Sidebar,
  SidebarBody,
  SidebarBodyCategory,
  SidebarBodyExpandItem,
  SidebarBodyCategoryItem,
  SidebarHeader,
  UserMenu,
  Breadcrumb: LayoutBreadcrumb,
};
export { TOP_BANNER_HEIGHT, default as TopBanner } from "./TopBanner";

export { useLayoutContext } from "./context";
export { type LayoutCanvasRect, toLayoutCanvasOverlayStyle, useLayoutCanvasRect } from "./useLayoutCanvasRect";

export type { LayoutContentBodyProps } from "./ContentBody";
export type { LayoutRootProps } from "./Root";
export type { LayoutSidebarProps } from "./Sidebar";
export type { LayoutSidebarBodyProps } from "./SidebarBody";
export type { LayoutSidebarBodyCategoryProps } from "./SidebarBodyCategory";
export type { LayoutSidebarBodyCategoryItemProps } from "./SidebarBodyCategoryItem";
export type { LayoutSidebarHeaderProps } from "./SidebarHeader";
